import React, { Component } from 'react';
import Img from '../../../../components/Img/Img';
import Panel from '../../../../components/outline/Panel';
import TableTransfer from '../../../../components/input/TableTransfer';
import { TAG_EDIT_PAGE_PANEL_NAME } from '../../../../constants/service/app/tagConstants';
import { comparePrePropsAndNextProps } from '../../../../lib/common';
import tagMainTabFollowSelected from '../../../../static/images/tag/tagTabMain/tag-tab-main-follow-selected-info.png';
import { columns } from './columns';
import './TagEditTagTabMain.scss';

class TagEditTagTabMain extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps, nextState) => {
    return comparePrePropsAndNextProps([
      [nextProps, this.props],
      [nextState, this.state],
    ]);
  };

  render() {
    const { tagTabMain, selectTagTrendMainItemList, onDragEndSelectTagTrendMainItemList } = this.props;
    const { itemList, selectedItemList } = tagTabMain;

    return (
      <Panel name={TAG_EDIT_PAGE_PANEL_NAME.TAG_EDIT_TAG_TREND_MAIN} className="tag-edit-tag-tab-main">
        <div className="panel-header">
          <div className="title">태그의 대표 컨텐츠 설정</div>
        </div>

        <div className="panel-body">
          <div className="tag-main-tab-info">
            <Img className="tag-main-tab-info-img" src={tagMainTabFollowSelected} />
            <div className="help-text">
              <div>* 앱의 태그 메인 탭에 노출될 때, 보여지는 대표 컨텐츠를 설정해주세요.</div>
              <div>* 대표 컨텐츠는 해당 태그가 연결되어 있는 상품 또는 상품 후기만 6개를 설정할 수 있습니다.</div>
              <div className="tag-related-item-condition-info">
                <div className="title">* 연결할 수 있는 상품의 조건</div>
                <div className="condition">- 상품 상태 : 판매 중, 품절 </div>
                <div className="condition">- 브랜드 상태 : 활성 </div>
                <div className="title">* 연결할 수 있는 상품 후기의 조건</div>
                <div className="condition">- 상품 후기 상태 : 작성완료(활성) </div>
                <div className="condition">- 작성자 : 활성 </div>
                <div className="condition">- 상품 상태 : 판매 중, 품절 </div>
                <div className="condition">- 브랜드 상태 : 활성 </div>
              </div>
            </div>
          </div>

          <TableTransfer
            dataSource={itemList}
            operations={['연결', '해제']}
            leftTitle={'태그에 연결된 상품, 상품 후기 리스트'}
            rightTitle={'태그의 대표 컨텐츠로 설정된 상품, 상품 후기'}
            leftTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  isFilter: true,
                }),
              rowClassName: (record) => (record.uncheckable ? 'uncheckable' : null),
            }}
            rightTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                }),
              headInfo: (
                <div className="selected-widget-item-head">
                  <div className="selected-widget-item-count">
                    선택된 아이템 개수 <span>{selectedItemList.list.length}</span>
                  </div>
                </div>
              ),
              // rowClassName: (record) => record.type === TAG_TAB_MAIN_CONTENTS_TYPE.PRODUCT ? "uncheckable" : null,
              list: selectedItemList.list,
              canDrag: true,
              onDragEnd: (newList) => onDragEndSelectTagTrendMainItemList(newList.list),
            }}
            onChange={(action, moveIdList) => selectTagTrendMainItemList(action, moveIdList)}
          />
        </div>
      </Panel>
    );
  }
}

export default TagEditTagTabMain;
